<template>
<div class="row modalConVinculo" >
        <ul>
            <li v-for="contenido in seccionDeMicrositio.ContenidoDeMicrositio" v-bind:key="contenido.ContenidoDeMicrositioId">
                <a data-toggle="modal" v-bind:data-target="'#modal_' + contenido.ContenidoDeMicrositioId">{{contenido.TextoDelVinculo}}</a>
            </li>
        </ul>
        <div v-for="contenido in seccionDeMicrositio.ContenidoDeMicrositio" v-bind:key="'modal_' + contenido.ContenidoDeMicrositioId" class="modal justify-content-center fade" v-bind:id="'modal_' + contenido.ContenidoDeMicrositioId" tabindex="-1" aria-labelledby="nombreDelModal" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="nombreDelModal">{{contenido.TextoDelVinculo}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <p class="page-text">{{contenido.TextoDelContenido}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>

<script>
export default {
    props: {
        seccionDeMicrositio: Object
    }
}
</script>

<style scoped>
.row{
    position: inherit !important;
}
.col-12{
    display: -webkit-box !important;
}

  a {
    color: rgb(33,33,33);
    cursor: pointer;
  }

  .modalConVinculo a {
    width: 100%;
    font-size: 1.2em;
    padding: 8px 0;
  }

  .modalConVinculo li {
    padding-bottom: 10px;
  }

  .modalConVinculo .modal-content {
    background-color: #FFF;
  }

  .modalConVinculo .close {
    color: #000;
  }
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/VinculoModalMicrositio.vue